export const Props = () => ({
  //--------------------------------------------------------------------------
  //                                 ID поста
  //--------------------------------------------------------------------------
  postId: {
    type: Number,
    required: true,
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});